import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DateControlsModule } from 'src/app/common/calendar/date-controls/date-controls.module';
import { CurrentComponent } from './current.component';
import { RaderModule } from './rader/rader.module';
import { SatAndRadarModule } from './sat-and-radar/sat-and-radar.module';
import { SatelliteModule } from './satellite/satellite.module';
import { WeatherMapModule } from './weather-map/weather-map.module';

@NgModule({
  declarations: [
    CurrentComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    DateControlsModule,

    WeatherMapModule,
    SatelliteModule,
    RaderModule,
    SatAndRadarModule
  ]
})
export class CurrentModule { }
